var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 19.486C16.2573 19.486 19.7829 15.9679 19.7829 11.704C19.7829 7.44754 16.2573 3.92188 11.9933 3.92188C7.73689 3.92188 4.21875 7.44754 4.21875 11.704C4.21875 15.9679 7.74442 19.486 12.0008 19.486ZM12.0008 17.9568C8.53544 17.9568 5.75558 15.1694 5.75558 11.704C5.75558 8.23856 8.5279 5.45871 11.9933 5.45871C15.4587 5.45871 18.2461 8.23856 18.2536 11.704C18.2536 15.1694 15.4662 17.9568 12.0008 17.9568ZM8.05329 10.2651H15.9559C16.3326 10.2651 16.5963 10.0315 16.5963 9.67745C16.5963 9.32338 16.3326 9.08231 15.9559 9.08231H8.05329C7.67662 9.08231 7.42048 9.32338 7.42048 9.67745C7.42048 10.0315 7.67662 10.2651 8.05329 10.2651ZM9.10045 12.7586H14.9163C15.2854 12.7586 15.5491 12.5176 15.5491 12.1635C15.5491 11.8094 15.2854 11.5684 14.9163 11.5684H9.10045C8.72377 11.5684 8.4601 11.8094 8.4601 12.1635C8.4601 12.5176 8.72377 12.7586 9.10045 12.7586ZM10.1853 15.2447H13.8239C14.2006 15.2447 14.4643 15.0112 14.4643 14.6571C14.4643 14.303 14.2006 14.0619 13.8239 14.0619H10.1853C9.80859 14.0619 9.54492 14.303 9.54492 14.6571C9.54492 15.0112 9.80859 15.2447 10.1853 15.2447Z",
    fill: "#AAAEB6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtend);
export default __webpack_public_path__ + "static/media/extend.f9f8ed0b83dcb5693d39c26fe3e65884.svg";
export { ForwardRef as ReactComponent };